<template>
  <div class="spinner">
    <div class="bounce1" :style="{ 'background-color': color }"></div>
    <div class="bounce2" :style="{ 'background-color': color }"></div>
    <div class="bounce3" :style="{ 'background-color': color }"></div>
  </div>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>

<style scoped>
.spinner {
  display: inline-block;
  margin: 0;
  padding: 0;
  text-align: center;
}

.spinner > div {
  width: 8px;
  height: 8px;
  background-color: rgb(255, 255, 255);

  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
</style>
